import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/fleet')({
  component: lazyRouteComponent(() => import('&/features/settings/fleet/pages/fleet-settings-page')),
});
